"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Legal = void 0;
const React = __importStar(require("react"));
const react_1 = require("react");
const antd_1 = require("antd");
const LegalContent_1 = require("src/configeek_assets/src/components/common/legal/LegalContent");
const ToolbarRow_1 = require("src/configeek_assets/src/components/anonymous/landing/ToolbarRow");
const Legal = () => {
    (0, react_1.useEffect)(() => {
        setTimeout(() => window.scrollTo({ top: 0 }), 0);
    }, []);
    return React.createElement(React.Fragment, null,
        React.createElement("div", { className: "anonymousLanding" },
            React.createElement("div", { className: "legal" },
                React.createElement(ToolbarRow_1.ToolbarRow, { logoAsLinkToHome: true }),
                React.createElement("div", null,
                    React.createElement("section", { className: "ug_anonym_section" },
                        React.createElement("div", { className: "ug_anonym_sectionContent pt-5 pb-5" },
                            React.createElement(antd_1.Row, { justify: "center", className: "pb-5" },
                                React.createElement(antd_1.Col, { span: 20 },
                                    React.createElement("div", { className: "header2" }, "Terms of Service"))),
                            React.createElement(antd_1.Row, { justify: "center", className: "pt-4 pb-5" },
                                React.createElement(antd_1.Col, { span: 16 },
                                    React.createElement(LegalContent_1.LegalContent, null)))))))));
};
exports.Legal = Legal;
